import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { buildApiUrl, API_CONFIG } from '../config/api';

const ApiStatusContext = createContext();

export const useApiStatus = () => {
  const context = useContext(ApiStatusContext);
  if (!context) {
    throw new Error('useApiStatus must be used within an ApiStatusProvider');
  }
  return context;
};

export const ApiStatusProvider = ({ children }) => {
  const [isApiDown, setIsApiDown] = useState(false);

  const checkApiStatus = async () => {
    try {
      await axios.get(buildApiUrl(API_CONFIG.ENDPOINTS.ALIVE), {
        timeout: 5000, // 5 segundos timeout
      });
      setIsApiDown(false);
    } catch (error) {
      console.error('API is down:', error);
      setIsApiDown(true);
    }
  };

  useEffect(() => {
    // Verificar imediatamente
    checkApiStatus();

    // Verificar a cada 30 segundos
    const interval = setInterval(checkApiStatus, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <ApiStatusContext.Provider value={{ isApiDown, checkApiStatus }}>
      {children}
    </ApiStatusContext.Provider>
  );
};